/**
 * ReviewActions - Footer component with Flag and Confirm & Save buttons
 */

interface ReviewActionsProps {
  onFlag: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  className?: string;
}

export function ReviewActions({
  onFlag,
  onConfirm,
  isLoading = false,
  className = "",
}: ReviewActionsProps) {
  return (
    <div
      className={`flex items-center gap-3 pt-6 border-t border-slate-200 dark:border-slate-800 ${className}`}
    >
      <button
        onClick={onFlag}
        disabled={isLoading}
        className="flex-1 flex items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-4 h-10 text-sm font-bold text-slate-700 hover:bg-slate-50 transition-colors dark:bg-slate-800 dark:border-slate-700 dark:text-slate-200 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="material-symbols-outlined text-lg">flag</span>
        Flag
      </button>
      <button
        onClick={onConfirm}
        disabled={isLoading}
        className="flex-1 flex items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 h-10 text-sm font-bold text-white hover:bg-black transition-colors dark:bg-primary dark:hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? (
          <>
            <svg
              className="animate-spin h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            Saving...
          </>
        ) : (
          "Confirm & Save"
        )}
      </button>
    </div>
  );
}

export default ReviewActions;
